import InspectItem from "./../../../views/inspection/InspectItem"
export const inspectitem = {
    path: '/inspectitem',
    name: 'InspectItem',
    component: InspectItem
  }


// WEBPACK FOOTER //
// ./src/router/index/inspection/index.js